import { Injectable } from '@angular/core'
import { AngularFireFunctions } from '@angular/fire/compat/functions'
import { ArtistId } from '../models/artist.model'
import { Observable } from 'rxjs'
import { PrAnalyzerGraph } from '../models/pr-analyzer-graph.model'
import * as moment from 'moment'

@Injectable({
  providedIn: 'root',
})
export class PrAnalyzerGraphService {
  constructor(private functions: AngularFireFunctions) {}

  findPrAnalyzerGraph(artistId: ArtistId, from: Date, to: Date): Observable<PrAnalyzerGraph[]> {
    return this.functions.httpsCallable<
      { artistId: string; from: string; to: string },
      PrAnalyzerGraph[]
    >('findPrAnalyzerGraph')({
      artistId,
      from: moment(from).format('YYYY-MM-DD'),
      to: moment(to).format('YYYY-MM-DD'),
    })
  }
}
